// src/components/VideoTutorials.js
import React from 'react';
import {Box, Typography, Grid, Card, CardMedia, CardContent} from '@mui/material';
import {useTranslation} from 'react-i18next';

export default function VideoTutorials() {
    const {t, i18n} = useTranslation();

    // Map of available videos per language
    const videos = {
        en: [
            {
                title: "Playground Tutorial",
                file: "/tutorials/videos/playground_EN.mp4",
                thumb: "/tutorials/thumbnails/playground_EN.jpg"
            },
            {
                title: "Tool Use Tutorial",
                file: "/tutorials/videos/usetool_EN.mp4",
                thumb: "/tutorials/thumbnails/usetool_EN.jpg"
            },
            {
                title: "Tool Creation Tutorial",
                file: "/tutorials/videos/createtool_EN.mp4",
                thumb: "/tutorials/thumbnails/createtool_EN.jpg"
            }
        ],
        ge: [
            {
                title: "Experimentierbereich-Tutorial",
                file: "/tutorials/videos/playground_DE.mp4",
                thumb: "/tutorials/thumbnails/playground_DE.jpg"
            },
            {
                title: "Tutorial zur Toolverwendung",
                file: "/tutorials/videos/usetool_DE.mp4",
                thumb: "/tutorials/thumbnails/usetool_DE.jpg"
            },
            {
                title: "Tutorial zur Tool-Erstellung",
                file: "/tutorials/videos/createtool_DE.mp4",
                thumb: "/tutorials/thumbnails/createtool_DE.jpg"
            }
        ],
        fr: [
            {
                title: "Tutoriel sur l'espace d'expérimentation",
                file: "/tutorials/videos/playground_FR.mp4",
                thumb: "/tutorials/thumbnails/playground_FR.jpg"
            },
            {
                title: "Tutoriel sur l'utilisation des outils",
                file: "/tutorials/videos/usetool_FR.mp4",
                thumb: "/tutorials/thumbnails/usetool_FR.jpg"
            },
            {
                title: "Tutoriel sur la création d'outils",
                file: "/tutorials/videos/createtool_FR.mp4",
                thumb: "/tutorials/thumbnails/createtool_FR.jpg"
            }
        ]
    };

    const lang = i18n.language || "en";
    const langVideos = videos[lang] || videos.en;

    return (
        <Box sx={{}}>
            <Typography variant="h5" mb={3}>
                {t("video_tutorials", "Video Tutorials")}
            </Typography>

            <Grid container spacing={2}>
                {langVideos.map((video, idx) => (
                    <Grid item xs={12} sm={6} md={3} lg={2.4} key={idx}>
                        <Card
                            elevation={1}
                            sx={{
                                borderRadius: 2,
                                mx: 'auto',
                                maxWidth: 260,
                                overflow: "hidden"
                            }}
                        >
                            <video
                                controls
                                controlsList="nodownload"
                                disablePictureInPicture
                                preload="none"
                                poster={video.thumb}
                                style={{
                                    width: "100%",
                                    height: 150,
                                    display: "block",
                                    borderRadius: "8px"
                                }}
                                src={video.file}
                            />
                            <CardContent sx={{pt: 1.25, pb: 1.75}}>
                                <Typography
                                    variant="subtitle1"
                                    noWrap
                                    title={video.title}
                                >
                                    {video.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
